import { render, staticRenderFns } from "./fancyDialogList.vue?vue&type=template&id=12c5c315&scoped=true"
import script from "./fancyDialogList.vue?vue&type=script&lang=js"
export * from "./fancyDialogList.vue?vue&type=script&lang=js"
import style0 from "./fancyDialogList.vue?vue&type=style&index=0&id=12c5c315&prod&scoped=true&lang=css"
import style1 from "./fancyDialogList.vue?vue&type=style&index=1&id=12c5c315&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5c315",
  null
  
)

component.options.__file = "fancyDialogList.vue"
export default component.exports